import styled from 'styled-components';

export const FeedBackBoxWrapper = styled.div`
  padding: 20px 16px 16px 16px;
`;
